import React, { useEffect } from "react";
import { Row, Col, InputGroup, DropdownButton, FormControl, Dropdown, ToastBody } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import QuestionOptInputText from './QuestionInputs/text';
import QuestionOptInputImage from './QuestionInputs/image';
import QuestionOptInputExternalVideo from './QuestionInputs/video_external';
import QuestionOptInputEmbedVideo from './QuestionInputs/video_embed';
import QuestionOptInputLink from './QuestionInputs/link';
// import QuestionOptInputLink from './QuestionInputs/link'
import { useMappedState, useDispatch } from 'redux-react-hook';

const E_OPT_TYPE = {
    0: "文字",
    1: "圖片",
    // 2: "外部影音",
    // 3: "嵌入式影音",
    // 4: "連結",
    // 5: "文字輸入(非必填)",
    6: "半開放", //文字輸入(必填)
}
export default function QuestionOptSingle(props) {
    const pid = useMappedState(state => state.pid);
    const tmpItems = useMappedState(state => state.tmpItems);
    const questionIndex = props.questionID;
    const optIndex = props.optIndex;
    // console.log("tmpItems", tmpItems);
    // return <div>aa</div>;
    let data = null;
    try {
        data = tmpItems[questionIndex].op[optIndex];
    } catch (e) {
        console.warn(e.stack);
    }
    const dispatch = useDispatch();

    // useEffect(() => {
    //   console.log(tmpItems);
    // });

    function onOptChange(e) {
        // console.log("onOptChange", e.target.value);

        let tmp = [...tmpItems];
        tmp[questionIndex].op[optIndex].na = e.target.value;
        // console.log(tmp);
        // setTmpItems(tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        // props.onOptChange(props.index, optIndex, optVal);
    }

    function onOptKeyChange(key, val) {
        console.log("onOptKeyChange", val);
        try {
            let tmp = [...tmpItems];
            tmp[questionIndex].op[optIndex][key] = val;
            dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
        } catch (e) {
            console.warn("[onOptKeyChange]", e.stack);
        }
    }


    function onSelect(val) {
        console.log(val);
        if (val != props.o_type) {
            let tmpValue = parseInt(val);
            if (isNaN(tmpValue) == false) {
                // console.log(onOptChange);

                let tmp = [...tmpItems];
                tmp[questionIndex].op[optIndex].o_type = tmpValue;
                // console.log(tmp);
                // setTmpItems(tmp);
                dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
            }
        }
    }

    function render() {
        if (data == null) return (<div>No Data</div>);

        var opts = Object.keys(E_OPT_TYPE).map(function (key) {
            return <Dropdown.Item key={key} eventKey={key}>{E_OPT_TYPE[key]}</Dropdown.Item>
        });

        let inputDom = null;
        switch (data.o_type) {
            case 1: //圖片
                inputDom = (<QuestionOptInputImage index={questionIndex} data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
                break;
            case 2: //外部影音(youtube)
                inputDom = (<QuestionOptInputExternalVideo index={questionIndex} data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
                break;
            case 4: //連結
                inputDom = (<QuestionOptInputLink index={questionIndex} data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
                break;
            case 3: //嵌入式影音
                inputDom = (<QuestionOptInputEmbedVideo data={data} onChange={onOptChange} onKeyChange={onOptKeyChange} pid={pid} />)
                break;
            case 4: //連結
                // TBD
                break;
            case 5: //文字輸入(必填)
            // inputDom = (<QuestionOptUserInputText index={questionIndex} data={"非必填題"} />)
            // break;
            case 6: //文字輸入(必填)
            // inputDom = (<QuestionOptUserInputText index={questionIndex} data={"必填題"} />)
            // break;
            case 0: //文字
            default:
                inputDom = (<QuestionOptInputText index={questionIndex} data={data.na} onChange={onOptChange} />)
                break;
        }
        return (
            <Row>
                <Col xs={1}>
                    {optIndex + 1}
                    {/* <input type="radio" name={props.questionID} value={data.na} className="" /> */}
                </Col>
                <Col xs={6} sm={7} lg={8} xl={9} className="text-left">
                    {inputDom}
                </Col>
                <Col xs={4} sm={3} lg={2} xl={1} className="text-left pb-1">
                    {tmpItems[questionIndex].cf.q_type == 3 ? null : <DropdownButton
                        className="btn-block no-bg text-left w-100"
                        size="sm"
                        variant="success"
                        title={E_OPT_TYPE[data.o_type]}
                        onSelect={onSelect}
                    >
                        {opts}
                    </DropdownButton>}
                </Col>
                <Col xs={1} className="text-right"><X onClick={props.onDelete} /></Col>
            </Row>
        );
    }

    return render();
}
